import { render, staticRenderFns } from "./ClubSelect.vue?vue&type=template&id=feda7e88&scoped=true"
import script from "./ClubSelect.vue?vue&type=script&lang=js"
export * from "./ClubSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feda7e88",
  null
  
)

export default component.exports